import assignmentList from "@/controllers/assignment/assignment-list";

export default {
  extends: assignmentList,
}
